import { Redirect, useLocalSearchParams } from "expo-router";

import { staffPath } from "../../../../src/lib/hosting";

export default function LegacyDirectorStatementRedirect() {
  const { caseId } = useLocalSearchParams<{ caseId?: string }>();
  const target = Array.isArray(caseId) ? caseId[0] : caseId;

  return <Redirect href={staffPath(target ? `/admin/cases/${target}/statement` : "/admin")} />;
}
